// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__VkIEL","hero":"Home_hero__VkeT1","logo":"Home_logo__IOQAX","tagline":"Home_tagline__q1jNE","startButton":"Home_startButton__Bekfq"};